import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { EVENT_TYPE, filterFalsy, getTourlaneMetaContext, PageType, Schema, withAsyncGlobalContext } from './snowplow';
export var trackUnsubscribeNewsletter = withAsyncGlobalContext(function (args) {
  var question = args.question,
      reason = args.reason,
      reasonCategory = args.reasonCategory,
      comment = args.comment;
  window.snowplow(EVENT_TYPE.SELF_DESCRIBING_EVENT, {
    event: {
      schema: Schema.UNSUBSCRIBE_EVENT,
      data: _objectSpread(_objectSpread({
        reason: reason,
        reason_category: reasonCategory
      }, question && {
        question: question
      }), comment && {
        comment: comment
      })
    },
    context: filterFalsy([getTourlaneMetaContext(PageType.UNSUBSCRIBE)])
  });
});